import { DownloadOutlined } from "@ant-design/icons";
import Button, { ButtonProps } from "@/shared/form/button";

export function BannerButton(props: ButtonProps) {
  return (
    <Button
      block
      icon={<DownloadOutlined />}
      className={"!border-none !text-[#1481e5] !text-small !font-medium"}
      {...props}
    />
  );
}
